import dayjs from 'dayjs'

import {
  parseDateRangeFromUrl,
  serializeDateRangeForUrl,
} from 'src/lib/url-date-range.utils'
import { getSearchParam } from 'src/lib/url-search-params.utils'

/** Earliest date with reliable actorType data for SMS/email analytics. */
export const ACTIVITY_ANALYTICS_EARLIEST_DATE = dayjs('2026-06-02')
  .startOf('day')
  .toDate()

export const clampActivityAnalyticsDateRange = (
  startDate: Date,
  endDate: Date
): [Date, Date] => {
  const earliest = dayjs(ACTIVITY_ANALYTICS_EARLIEST_DATE)
  let start = dayjs(startDate).startOf('day')
  let end = dayjs(endDate).endOf('day')

  if (start.isBefore(earliest, 'day')) {
    start = earliest
  }

  if (end.isBefore(start, 'day')) {
    end = dayjs().endOf('day')
  }

  return [start.toDate(), end.toDate()]
}

export const getActivityAnalyticsUrlDateRange = (): {
  defaultStartDate: Date
  defaultEndDate: Date
} => {
  const dateRangeUrlString = getSearchParam('dateRange')
  const parsed = parseDateRangeFromUrl(dateRangeUrlString)
  const defaultEndDate = dayjs().endOf('day').toDate()

  if (parsed) {
    const [start, end] = clampActivityAnalyticsDateRange(parsed[0], parsed[1])
    return { defaultStartDate: start, defaultEndDate: end }
  }

  return {
    defaultStartDate: ACTIVITY_ANALYTICS_EARLIEST_DATE,
    defaultEndDate,
  }
}

export const activityAnalyticsDateRangeNeedsUrlSync = (
  startDate: Date,
  endDate: Date
): boolean => {
  const raw = getSearchParam('dateRange')
  if (!raw) return false

  const parsed = parseDateRangeFromUrl(raw)
  if (!parsed) return false

  const desiredSerialized = serializeDateRangeForUrl(startDate, endDate)
  const urlSerialized = serializeDateRangeForUrl(parsed[0], parsed[1])

  return desiredSerialized !== urlSerialized
}
